import { FlowType } from "../../constants/FlowType";
import ReviewAndSignBase from "../shared/ReviewAndSign/ReviewAndSignBase";
import { getProducerFlowVerticalStepperElements } from "../../constants/ProducerFlowVerticalStepperElementsFactory";
import { GeaoPaths } from "../../constants/GeaoPaths";
import React, { useContext } from "react";
import { GeaoContext } from "../../GeaoContextProvider";
import { ClientConfigurationContext } from "../../../../context/ClientConfigurationContextProvider";

/**
 * ProducerSubmitApplication component for offshore IA agents.
 * Displays the submit application page after background information for offshore residents.
 * Reuses ReviewAndSignBase but shows only the Confidentiality and Nondisclosure Agreement
 * portion (no FCRA review-and-sign documents) under a "Submit Application" heading.
 */
export default function ProducerSubmitApplication() {
    const { agentInterview } = useContext(GeaoContext);
    const clientConfiguration = useContext(ClientConfigurationContext);

    // Get the dynamic vertical stepper with offshore settings
    const enableOffshore = clientConfiguration?.enableOffshore === true;
    const isOffshoreResident = agentInterview?.questionAnswers?.OffshoreResident?.answer === "true";
    const verticalStepperElements = getProducerFlowVerticalStepperElements(enableOffshore, isOffshoreResident);

    return (
        <ReviewAndSignBase
            flowType={FlowType.Producer}
            verticalStepperElements={verticalStepperElements}
            currentStepperItem="Submit Application"
            componentName="ProducerSubmitApplication"
            header="Submit Application"
            title="Submit Application"
            showReviewDocuments={false}
            requireFcraSigned={false}
            saveAndExitPath={GeaoPaths.ProducerWelcomeChecklist}
            validateOnSaveAndExit={false}
        />
    );
}
